<template>
  <div class="container">
    <back title="教学作品"></back>

    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/works/banner.jpg"
    ></landingBanner>
    <div class="contents">
      <tagPage :tagArr="tagArr" color="#924e11" titleActiveColor="#924e11" num="4"></tagPage>
      <indexTitle title1="选择课程 了解学费" title2="Choose a course to learn about tuition"></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "",
    
    };
  },
  components: {
    back: () => import("../../../components/head/back"),
    tagPage: () => import("@/components/common/tagPage"),
    landingBanner: () => import("@/components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    footerForm: () => import("@/components/form/footerForm"),
    indexTitle:()=>import("@/components/common/indexTitle")
  },
  mothods() {}
};
</script>
<style lang="less" scoped>
@nomal-pink: rgb(249, 213, 227);
@nomal-blur: rgb(206, 233, 254);
@change-bgc: linear-gradient(
  to right,
  rgb(249, 213, 227) 0%,
  rgb(206, 233, 254) 100%
);
@black: #000;
.main{
  margin-top: 50px;
}
.contents {
  padding: 0.9375rem;
}
.container{
  width:100%;
  padding:0;
}
</style>